
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '登録は無料ですか？',
      answer: '無料です。'
    },
    {
      question: '副業でも可能ですか？',
      answer: '可能です。'
    },
    {
      question: '稼働率は調整できますか？',
      answer: '可能です。'
    },
    {
      question: '必ず案件を紹介してもらえますか？',
      answer: 'スキルに応じて案件をご紹介します。'
    }
  ];

  return (
    <section id="faq" className="py-12 bg-[#112240]">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 text-white">
          よくある質問
        </h2>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-[#1a2f4e] rounded-lg overflow-hidden border border-slate-700">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-4 py-3 text-left flex justify-between items-center hover:bg-[#1e3a5f] transition-colors cursor-pointer"
              >
                <span className="font-semibold text-sm text-white">{faq.question}</span>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-xl text-amber-400`}></i>
              </button>
              {openIndex === index && (
                <div className="px-4 py-3 bg-[#0d1b2e] border-t border-slate-700">
                  <p className="text-sm text-slate-300">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}